const SIGNAL_TIMEOUT_MS = 1000

const raceSignal = async (methodName, options) => {
	const signalMethod = window.PublicKeyCredential?.[methodName]
	if (!signalMethod || !options) return
	let timeoutId
	try {
		// Safari 26.0-26.3 never resolves the Signal promises (WebKit bug 298951, fixed in 26.4)
		await Promise.race([
			signalMethod.call(window.PublicKeyCredential, options),
			new Promise(resolve => { timeoutId = setTimeout(resolve, SIGNAL_TIMEOUT_MS) })
		])
	} catch (error) {
		console.error(`${methodName} error:`, error)
	} finally {
		clearTimeout(timeoutId)
	}
}

export const signalAcceptedCredentials = (options) => raceSignal('signalAllAcceptedCredentials', options)

export const signalUnknownCredential = (options) => raceSignal('signalUnknownCredential', options)